export const SET_MEMBER = 'SET_MEMBER';
export const CLEAR_MEMBER = 'CLEAR_MEMBER';

export const mutations = {
    [SET_MEMBER](state, payload) {
        state.user = payload;
        state.isLogin = true;
    },

    [CLEAR_MEMBER](state) {
        state.user = null;
        state.isLogin = false;
    },
};
